import { ShieldCheck, Clock, MessageSquareText } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import EstimateForm from "@/components/EstimateForm";
import { PHONE_DISPLAY, TEL_HREF, SMS_HREF } from "@/data/site";

const POINTS = [
  { icon: ShieldCheck, title: "Insured", body: "Professional service with added peace of mind." },
  { icon: Clock, title: "Quick Response", body: "Prefer to talk now? Call or text and we'll respond." },
  { icon: MessageSquareText, title: "Clear Communication", body: "We'll follow up about your request and next steps." },
];

export default function FreeEstimate() {
  return (
    <>
      <Seo
        title="Request a Free Estimate | Authentically Yours Greensboro NC"
        description="Request a free estimate for cleaning or junk removal in Greensboro, NC. Tell us about your property and we'll follow up about your free estimate."
        path="/free-estimate"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Contact", path: "/free-estimate" },
        ]}
      />
      <PageHero
        eyebrow="Free Estimate"
        title="Request Your Free Estimate"
        intro="Tell us what you need and we'll get back to you about your free estimate. Prefer to talk? Call or text us anytime."
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Contact", path: "/free-estimate" },
        ]}
      />

      <section className="container-x py-16 sm:py-24 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <Reveal>
            <h2 className="text-3xl sm:text-4xl text-ink">Let's talk about your property</h2>
            <p className="mt-4 text-ink/70 leading-relaxed">
              Share a few details and we'll help you determine the right service.
              The more you tell us, the better we can help.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a href={TEL_HREF} className="btn-primary" data-testid="estimate-call">Call {PHONE_DISPLAY}</a>
              <a href={SMS_HREF} className="btn-ghost" data-testid="estimate-text">Text Us</a>
            </div>

            <ul className="mt-10 space-y-6">
              {POINTS.map(({ icon: Icon, title, body }) => (
                <li key={title} className="flex items-start gap-4">
                  <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center border border-rose/30 text-rose" aria-hidden="true">
                    <Icon size={20} strokeWidth={1.25} />
                  </span>
                  <div>
                    <p className="font-serif text-xl text-ink">{title}</p>
                    <p className="text-ink/65 text-sm mt-1">{body}</p>
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <EstimateForm />
        </div>
      </section>
    </>
  );
}
